import { combineReducers } from "redux";
import currentPropertyDetailsReducer from "./currentPropertyDetailsReducer";

const curPropertyDetailsReducer = combineReducers({
    currentPropertyDetails: currentPropertyDetailsReducer

});

export default curPropertyDetailsReducer;